import { colors } from '@mui/material';
import { experimental_extendTheme as extendTheme } from '@mui/material/styles';

import palette from './palette';
import { communityPalettes } from './community';
import { createTypography } from './typography';
import components from './components';

const darkText = {
  primary: '#E5E7EB',
  secondary: '#AEB8C5',
  link: '#90CAF9',
};

const darkApp = {
  ...palette.app,
  labelDefault: darkText.secondary,
  metricBackground: 'rgba(255,255,255,0.08)',
  popupBorder: 'rgba(255,255,255,0.24)',
  schedulePastBackground: 'rgba(255,255,255,0.12)',
  scheduleSelectedBackground: 'rgba(144,202,249,0.22)',
  scheduleValueBackground: 'rgba(255,255,255,0.08)',
  tooltipBackground: '#0B0F17',
  tooltipBorder: 'rgba(255,255,255,0.12)',
};

const darkPalette = {
  ...palette,
  mode: 'dark',
  grey: colors.grey,
  text: darkText,
  link: darkText.link,
  icon: '#CBD5E1',
  background: {
    default: '#0B0F17',
    paper: '#121826',
  },
  divider: 'rgba(255,255,255,0.12)',
  app: darkApp,
};

const lightPalette = {
  ...palette,
  mode: 'light',
  grey: colors.grey,
};

const createTheme = (light, dark) => extendTheme({
  colorSchemes: {
    light: {
      palette: light,
    },
    dark: {
      palette: dark,
    },
  },
  typography: createTypography({
    primary: 'var(--mui-palette-text-primary)',
    secondary: 'var(--mui-palette-text-secondary)',
  }),
  components,
});

export const themeOptions = [
  {value: 'classic', label: '经典'},
  {value: 'catppuccin', label: '猫布奇诺'},
  {value: 'solarized', label: '日光'},
  {value: 'gruvbox', label: '复古暖色'},
  {value: 'tokyoNight', label: '东京夜'},
  {value: 'rosePine', label: '玫瑰松'},
];

export const themes = {
  classic: createTheme(lightPalette, darkPalette),
  ...Object.fromEntries(
    Object.entries(communityPalettes).map(([name, schemes]) => [
      name,
      createTheme(schemes.light, schemes.dark),
    ]),
  ),
};

export default themes.classic;
